import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  Link,
  Button,
  Box,
  MenuItem,
  Switch,
  Divider
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  //ArrowBack as ArrowBackIcon,
  MenuOpen as MenuOpenIcon,
  Add as AddIcon,
  ContactSupport as ContactSupportIcon,
} from "@material-ui/icons";
import classNames from "classnames";
import ttAPI from '../../api/ttAPI';

// styles
import useStyles from "./styles";

// components
import {  Typography } from "../Wrappers/Wrappers";
import SelectRetest from '../../components/Retest/SelectRetest';

// localStorage
import { useLocalStorage } from 'usehooks-ts'

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut, useUserState, getUserInfo, getDefaultPricing,
         getRegions, getGeoRegions, isUserLoggedIn, getDisposalCodes,
         /*getServices,*/ getTestingScopes, getRefundCategories, getRefundTypes
} from "../../context/UserContext";

export default function Header(props) {
    // global
  var { user_name, admin_roles, rcd_price, regions, geo_regions, disposal_codes,
        /*services,*/ testing_scopes/*, fakeLogin */, refund_categories,
        refund_types} = useUserState();
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [profileMenu, setProfileMenu] = useState(null);
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [autoOpenTeamsLinkAfterJobConfirmation, setAutoOpenTeamsLinkAfterJobConfirmation] =
        useState(localStorage.getItem('auto_open_teams_link_after_job_confirmation') !== undefined &&
                 localStorage.getItem('auto_open_teams_link_after_job_confirmation') !== null ?
                 localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true' : false);
  var [openJobInNewTab, setOpenJobInNewTab] =
       useState(localStorage.getItem('open_job_in_new_tab') !== undefined &&
                localStorage.getItem('open_job_in_new_tab') !== null ?
                localStorage.getItem('open_job_in_new_tab') === 'true' : false);
  var [allCustomerAssets, setAllCustomerAssets] = useLocalStorage('download_customer_assets_all', false);
  var [allCustomerAssetsPopup, setAllCustomerAssetsPopup] = useLocalStorage('download_customer_assets_popup', true);
  var [showSiteAssetsExpiryByMonth, setShowSiteAssetsExpiryByMonth] = useLocalStorage('display_site_assets_expiry_by_month_in_job', true);

       /*useState(localStorage.getItem('download_customer_assets_all') !== undefined &&
                localStorage.getItem('download_customer_assets_all') !== null ?
                localStorage.getItem('download_customer_assets_all') === 'true' : false);*/



  useEffect(() => {
     const fetchUserData = async() => {
       await getUserInfo(userDispatch, props.history, setIsLoading, setError);
       localStorage.setItem("user_data_refreshed", true)
     };

     const fetchDefaultPricing = async() => {
       await getDefaultPricing(userDispatch, props.history, setIsLoading, setError);
     };

     const fetchRegions = async() => {
       await getRegions(userDispatch, props.history, setIsLoading, setError);
     };

     const fetchGeoRegions = async() => {
       await getGeoRegions(userDispatch, props.history, setIsLoading, setError);
     };

     const fetchIsUserLoggedIn = async() => {
       await isUserLoggedIn(userDispatch, props.history, setIsLoading, setError);
     };

     const fetchDisposalCodes = async() => {
       await getDisposalCodes(userDispatch, props.history, setIsLoading, setError);
     };

     /*const fetchServices = async() => {
       await getServices(userDispatch, props.history, setIsLoading, setError);
     };*/

     const fetchTestingScopes = async() => {
       await getTestingScopes(userDispatch, props.history, setIsLoading, setError);
     };

     const fetchRefundCategories = async() => {
       await getRefundCategories(userDispatch, props.history, setIsLoading, setError);
     };

     const fetchRefundTypes = async() => {
       await getRefundTypes(userDispatch, props.history, setIsLoading, setError);
     };

     //if (!fakeLogin) {
         /*if (user_name === undefined || user_name === '' || user_name === null) {
           //console.log('username ? fetch user data', user_name, fakeLogin);
           fetchUserData();
         }
         else {
           //console.log('username ? fetchisuserloggedin', user_name, fakeLogin);
           fetchIsUserLoggedIn();
         }*/

         if (user_name === undefined || user_name === '' || user_name === null ||
             localStorage.getItem("user_data_refreshed") === undefined || !localStorage.getItem("user_data_refreshed")) {
           fetchUserData();
         }
         else {
           //console.log('username ? fetchisuserloggedin', user_name, fakeLogin);
           fetchIsUserLoggedIn();
         }



         if (rcd_price === undefined || rcd_price === '' || rcd_price === 0) {
           fetchDefaultPricing();
         }

         if (regions === undefined || regions === null || regions.length <= 0) {
           fetchRegions();
         }

         if (geo_regions === undefined || geo_regions === null || geo_regions.length <= 0) {
           fetchGeoRegions();
         }

         if (disposal_codes === undefined || disposal_codes === null || disposal_codes.length <= 0) {
           fetchDisposalCodes();
         }

         /*if (services === undefined || services === null || services.length <= 0) {
           fetchServices();
         }*/

         if (testing_scopes === undefined || testing_scopes === null || testing_scopes.length <= 0) {
           fetchTestingScopes();
         }

         if (refund_categories === undefined || refund_categories === null || refund_categories.length <= 0) {
           fetchRefundCategories();
         }

         if (refund_types === undefined || refund_types === null || refund_types.length <= 0) {
           fetchRefundTypes();
         }

         if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === undefined ||
                  localStorage.getItem('auto_open_teams_link_after_job_confirmation') === null ||
                  localStorage.getItem('auto_open_teams_link_after_job_confirmation') === '') {
             localStorage.setItem('auto_open_teams_link_after_job_confirmation', false);
         }

         if (localStorage.getItem('open_job_in_new_tab') === undefined ||
                  localStorage.getItem('open_job_in_new_tab') === null ||
                  localStorage.getItem('open_job_in_new_tab') === '') {
             localStorage.setItem('open_job_in_new_tab', false);
         }

         if (localStorage.getItem('download_customer_assets_all') === undefined ||
                  localStorage.getItem('download_customer_assets_all') === null ||
                  localStorage.getItem('download_customer_assets_all') === '') {
             localStorage.setItem('download_customer_assets_all', false);
         }

         if (localStorage.getItem('download_customer_assets_popup') === undefined ||
                  localStorage.getItem('download_customer_assets_popup') === null ||
                  localStorage.getItem('download_customer_assets_popup') === '') {
             localStorage.setItem('download_customer_assets_popup', true);
         }

         if (localStorage.getItem('display_site_assets_expiry_by_month_in_job') === undefined ||
                  localStorage.getItem('display_site_assets_expiry_by_month_in_job') === null ||
                  localStorage.getItem('display_site_assets_expiry_by_month_in_job') === '') {
             localStorage.setItem('display_site_assets_expiry_by_month_in_job', true);
         }
     //}

  }, [userDispatch, user_name, rcd_price, regions, geo_regions, disposal_codes]);

  function openHelpDesk() {
    window.open('https://aoteam.atlassian.net/servicedesk/customer/portal/4/group/11/create/42','_blank');
  }

  function onClickAutoOpenTeamsLinkSwitch() {
      setAutoOpenTeamsLinkAfterJobConfirmation(!autoOpenTeamsLinkAfterJobConfirmation);
      localStorage.setItem('auto_open_teams_link_after_job_confirmation',!autoOpenTeamsLinkAfterJobConfirmation);
  }

  function onClickOpenJobInNewTab() {
      setOpenJobInNewTab(!openJobInNewTab);
      localStorage.setItem('open_job_in_new_tab', !openJobInNewTab);
  }

  function onClickAllCustomerAssets() {
      setAllCustomerAssets(!allCustomerAssets);
      localStorage.setItem('download_customer_assets_all', !allCustomerAssets);
  }

  function onClickAllCustomerAssetsPopup() {
      setAllCustomerAssetsPopup(!allCustomerAssetsPopup);
      localStorage.setItem('download_customer_assets_popup', !allCustomerAssetsPopup);
  }

  function onClickShowSiteAssetsExpiryByMonth() {
      setShowSiteAssetsExpiryByMonth(!showSiteAssetsExpiryByMonth);
      localStorage.setItem('display_site_assets_expiry_by_month_in_job', !showSiteAssetsExpiryByMonth);
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <MenuOpenIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype}>
          TESTntel {process.env.REACT_APP_ENV.includes('production') ? '' : `[${process.env.REACT_APP_ENV}]`}
        </Typography>
        <div className={classes.selectRetest}><SelectRetest labelName="Book Retest"/></div>
        <Link href="#/app/job/add" underline="none">
            <Button variant={'contained'} className={classes.addJobButton}>
                <Box mr={1} display={'flex'}>
                    <AddIcon />
                </Box>
                Add Job
            </Button>
        </Link>
        <div className={classes.grow} />
        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => openHelpDesk()}
        >
          <ContactSupportIcon classes={{ root: classes.headerIcon }} />
        </IconButton>
        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon classes={{ root: classes.headerIcon }} />
        </IconButton>
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {user_name}
            </Typography>
          </div>
          {/*<MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
          }  <AccountIcon className={classes.profileMenuIcon} /> Profile
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Tasks
          </MenuItem>
          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Messages
          </MenuItem>*/}
          <Divider className={classes.divider} />
          <div style={{marginLeft: '15px', fontWeight:'bold'}}>Quick Setups</div>
          <MenuItem>
            <Box display={"flex"} alignItems={"center"}>
              <Typography weight={"medium"}>
                  Auto Open Teams Link After Job Confirmation
              </Typography>
              <Switch color={"primary"} checked={autoOpenTeamsLinkAfterJobConfirmation} onClick={onClickAutoOpenTeamsLinkSwitch}/>
          </Box>
          </MenuItem>
          <MenuItem>
            <Box display={"flex"} alignItems={"center"}>
              <Typography weight={"medium"}>
                  Open Job in New Tab
              </Typography>
              <Switch color={"primary"} checked={openJobInNewTab} onClick={onClickOpenJobInNewTab}/>
          </Box>
          </MenuItem>
          <Divider />
          <MenuItem>
            <Box display={"flex"} alignItems={"center"}>
              <Typography weight={"medium"}>
                  Download Customer Assets - ALL
              </Typography>
              <Switch color={"primary"} checked={allCustomerAssets} onClick={onClickAllCustomerAssets}/>
          </Box>
          </MenuItem>
          <MenuItem>
            <Box display={"flex"} alignItems={"center"}>
              <Typography weight={"medium"}>
                  Display Download Customer Assets - POPUP WINDOW
              </Typography>
              <Switch color={"primary"} checked={allCustomerAssetsPopup} onClick={onClickAllCustomerAssetsPopup}/>
          </Box>
          </MenuItem>
          <Divider />
          <MenuItem>
              <Box display={"flex"} alignItems={"center"}>
                <Typography weight={"medium"}>
                    Display Site Assets Expiry by Month on Job Edit Page
                </Typography>
                <Switch color={"primary"} checked={showSiteAssetsExpiryByMonth} onClick={onClickShowSiteAssetsExpiryByMonth}/>
            </Box>
          </MenuItem>
          <Divider className={classes.divider} />
          <div className={classes.profileMenuUser}>
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => signOut(userDispatch, props.history)}
            >
              Sign Out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
